<template>
    <v-row class="no-frame">
        <v-col class="no-frame col-3 pr-1">
            <c-flip-card
                :enabled = "liftmanager && liftmanager.length > 0"
                v-model  = "flipCusLim"
                class    = "w-100"
                color    = "white--text"
                :top     = "3"
            >
                <template v-slot:front >
                    <c-site-contact-row-menu
                        title     = "Ansprechpartner"
                        :contacts = "contacts.customer"
                        class     = "mr-1 w-100"
                    >
                        <template v-slot:right>
                            <div class="mr-7" v-if="liftmanager && liftmanager.length > 0">
                                Liftmanager
                            </div>
                        </template>
                    </c-site-contact-row-menu>
                </template>
                <template v-slot:back>
                    <c-site-contact-row-menu
                        v-if="liftmanagerContacts"
                        title     = "Liftmanager"
                        :contacts = "liftmanagerContacts"
                        class     = "mr-2 w-100"
                    >
                        <template v-slot:right>
                            <div class="mr-7">
                                Ansprechpartner
                            </div>
                        </template>
                    </c-site-contact-row-menu>
                </template>
            </c-flip-card>
        </v-col>
        <v-col class="no-frame col-3">
            <c-site-contact-row-menu
                title     = "Ansprechpartner vor Ort"
                :contacts = "contacts.onSite"
                class     = "mr-1"
            />
        </v-col>
        <v-col class="no-frame col-3">
            <c-site-contact-row-menu
                :title     = "'Wartungsnehmer' + ((contracts && contracts.mntContract && contracts.mntContract.company) ? ' - ' + contracts.mntContract.company.name : '')"
                :contacts = "contacts.maintenance"
                class     = "mr-1"
            >
                <template v-slot:right>
                    <div class="mnt-contract" v-if="contracts && contracts.mntContract">
                        {{ contracts.mntContract.contracttype ? contracts.mntContract.contracttype.name : '' }}
                    </div>
                </template>
            </c-site-contact-row-menu>
        </v-col>
        <v-col class="no-frame col-3">
            <c-flip-card
                v-model="flipZusEsc"
                class="w-100"
                color="white--text"
                :top="3"
            >
                <template v-slot:front >
                    <c-site-contact-row-menu
                        :title     = "'Notrufnehmer' + ((contracts && contracts.escContract && contracts.escContract.company) ? ' - ' + contracts.escContract.company.name : '')"
                        :contacts = "contacts.emc"
                        class     = "mr-1"
                    >
                        <template v-slot:right>
                            <div class="mr-7">
                                ZÜS
                            </div>
                        </template>
                    </c-site-contact-row-menu>
                </template>
                <template v-slot:back>
                    <c-site-contact-row-menu
                        :title     = "(contracts && contracts.zusContract && contracts.zusContract.company) ? ('ZÜS - ' + contracts.zusContract.company.name) : 'ZÜS'"
                        :contacts = "contacts.zus"
                        class     = "w-100"
                   >
                        <template v-slot:right>
                            <div class="mr-7">
                                Notrufnehmer
                            </div>
                        </template>
                    </c-site-contact-row-menu>
                </template>
            </c-flip-card>
        </v-col>
    </v-row>
</template>

<script>

import CSiteContactRowMenu from "@/modules/msd/unit/components/top/CSiteContactRowMenu";
import CFlipCard           from "@/modules/core/components/utils/CFlipCard";

export default {
    name: "CSiteContactRow",

    components: {
        CFlipCard,
        CSiteContactRowMenu
    },
    props: {
        contacts: {
            required: true,
            type    : Object
        },

        contracts: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },
        liftmanager: {
            required: false,
            type    : Array,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        flipZusEsc: false,
        flipCusLim:false,
        showMail: false,
        liftmanagerContacts: null,
        mail: {
            attachments: [],
            to         : [],
            cc         : [],
            selected   : {
                to     : [],
                cc     : [],
            }
        }
    }),

    mounted() {
        this.convertToContacts();
    },

    watch: {
        liftmanager () {
            this.convertToContacts();
        }
    },

    methods: {
        convertToContacts () {
            if (!this.liftmanager) {
                return;
            }

            this.liftmanagerContacts = [];
            this.liftmanager.forEach(liftmanager => {
                const contact = {
                    firstname: liftmanager.firstname,
                    name     : liftmanager.lastname,
                    email    : liftmanager.email,
                    company: {
                        name: liftmanager.branch.city
                    },
                    phonenumbers: []
                }

                if (liftmanager.phone) {
                    contact.phonenumbers.push ({
                        type: {
                            id: 1
                        },
                        number: liftmanager.phone
                    })
                }

                if (liftmanager.mobile) {
                    contact.phonenumbers.push ({
                        type: {
                            id: 2
                        },
                        number: liftmanager.mobile
                    })
                }

                this.liftmanagerContacts.push (contact);
            })
        }
    }
}
</script>

<style scoped>

.mnt-contract {
    margin-top: 2px;
    height: 18px;
    background-color: white;
    color: black;
    width: 130px;
    border-radius: 9px;
    font-size: 10pt;
    text-align: center;
    line-height: 18px;
}

</style>

